export function getEmptyCardItems(numberItems) {
    return Array.from({
        length: numberItems,
    });
}
